import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dropdown,
  Menu,
  Popconfirm,
  Space,
  type MenuProps,
} from "antd";

import { TIPO_JOGO, type CatalogItem } from "../../../services/admin";
import {
  getEditLabel,
  getModuleForJogo,
  getModuleForPassatempo,
} from "../Editor/registry";

export const catalogItemId = (item: CatalogItem): number =>
  item.source === "passatempo" ? item.passatempo.id : item.jogo.idJogo;

/** Regerar existe só onde há endpoint: cruzada sem editor (ou que mantém o Regerar), sudoku e caça-palavras. */
export function canRegenerate(item: CatalogItem): boolean {
  if (item.source === "jogo") {
    return (
      item.jogo.idTipo === TIPO_JOGO.SUDOKU ||
      item.jogo.idTipo === TIPO_JOGO.CACA_PALAVRAS
    );
  }
  const module = getModuleForPassatempo(item.passatempo.estilosDePassatemposId);
  return (
    !module ||
    (module.entry.catalog === "passatempo" && !!module.entry.keepsRegenerate)
  );
}

interface Props {
  item: CatalogItem;
  onInfo: (item: CatalogItem) => void;
  onRegenerate: (item: CatalogItem) => void;
  onDelete: (item: CatalogItem) => void;
}

export const RowActions: React.FC<Props> = ({
  item,
  onInfo,
  onRegenerate,
  onDelete,
}) => {
  const navigate = useNavigate();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const id = catalogItemId(item);
  const editorModule =
    item.source === "passatempo"
      ? getModuleForPassatempo(item.passatempo.estilosDePassatemposId)
      : getModuleForJogo(item.jogo.idTipo);

  const close = () => setMenuOpen(false);
  const items: MenuProps["items"] = [
    ...(editorModule
      ? [
          {
            key: "info",
            label: "Informações",
            onClick: () => {
              close();
              onInfo(item);
            },
          },
        ]
      : []),
    ...(canRegenerate(item)
      ? [
          {
            key: "regenerate",
            label: "Regerar",
            onClick: () => {
              close();
              onRegenerate(item);
            },
          },
        ]
      : []),
    ...(editorModule || canRegenerate(item)
      ? [{ type: "divider" as const }]
      : []),
    {
      key: "delete",
      label: "Excluir",
      danger: true,
      onClick: () => {
        close();
        setConfirmOpen(true);
      },
    },
  ];
  const menu = <Menu items={items} />;

  return (
    <Space>
      <Button
        size="small"
        onClick={() =>
          editorModule
            ? navigate(`/admin/editor/${editorModule.kind}/${id}`)
            : onInfo(item)
        }
      >
        {editorModule ? getEditLabel(editorModule) : "Informações"}
      </Button>
      <Popconfirm
        title="Excluir este jogo?"
        okText="Excluir"
        okButtonProps={{ danger: true }}
        cancelText="Cancelar"
        visible={confirmOpen}
        onVisibleChange={(open) => {
          if (!open) setConfirmOpen(false);
        }}
        onConfirm={() => {
          setConfirmOpen(false);
          onDelete(item);
        }}
        onCancel={() => setConfirmOpen(false)}
      >
        <span>
          <Dropdown
            overlay={menu}
            trigger={["click"]}
            visible={menuOpen}
            onVisibleChange={setMenuOpen}
          >
            <Button size="small" aria-label="Mais ações">
              ⋯
            </Button>
          </Dropdown>
        </span>
      </Popconfirm>
    </Space>
  );
};

export default RowActions;
